import { GET_ITEMS } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_ITEMS:
            return action.payload;
        default:
            return state;
    }
}
